import {
  Box,
  Button,
  Center,
  Divider,
  Flex,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { useFormContext } from "react-hook-form";
import { FinishStep, SectionsForm } from "../../components";
import { IPostBuyNow } from "../../interfaces/PurchaseNow";
import { IProductComplete } from "../../interfaces/Products/IProductDetail";
import { formatCurrency } from "../../utils/currency";
import { useTranslation } from "react-i18next";
interface IProps {
  isLoading: boolean;
  hasPrice: boolean;
  product: IProductComplete | undefined;
}
const PurchaseStep4 = ({ isLoading = false, hasPrice, product }: IProps) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  const { watch } = useFormContext<IPostBuyNow>();
  const selectedPlanId = watch("plan_id");
  const isAcceptedTermProduct = !!watch("term_of_product");
  const selectedPlan = product?.plan.find((p) => p.id === selectedPlanId);

  return (
    <SectionsForm
      title={t("marketplace.comprar_agora.purchase_step_4.title_section")}
      number={"04"}
    >
      {!!selectedPlanId && !!isAcceptedTermProduct ? (
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "24px",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <Text
              fz={{ base: 24 }}
              fw={{ base: 600 }}
              lh={{ base: "37.2px" }}
              c={"basic.5"}
            >
              {t("marketplace.comprar_agora.purchase_step_4.title")}
            </Text>

            <Flex
              gap="24px"
              w={"100%"}
              align={"center"}
              justify={"space-between"}
            >
              <Text color={theme.colors.basic[5]} fz="16px" fw={500} lh="16px">
                {product?.product?.title} - {selectedPlan?.name}
              </Text>
              <Flex gap="6px" align={"end"} justify={"end"}>
                {!!selectedPlan?.qty_of_installments &&
                selectedPlan.qty_of_installments > 0 ? (
                  <Text
                    color={theme.colors.basic[4]}
                    fw={500}
                    fz="12px"
                    lh={"16px"}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {selectedPlan?.qty_of_installments}
                    {t("marketplace.comprar_agora.purchase_step_4.x_of")}
                  </Text>
                ) : null}
                <Text
                  color={theme.colors.basic[5]}
                  fz="16px"
                  fw={500}
                  tt="uppercase"
                  lh="16px"
                >
                  {!!selectedPlan?.price
                    ? selectedPlan.qty_of_installments > 0
                      ? formatCurrency(
                          selectedPlan.price / selectedPlan.qty_of_installments
                        )
                      : formatCurrency(selectedPlan?.price)
                    : t("marketplace.comprar_agora.purchase_step_4.free")}
                </Text>
              </Flex>
            </Flex>

            <Divider w={"100%"} color="basic.2" />
            {hasPrice ? (
              <Flex
                bg={theme.colors.primaryOpacity[2]}
                p="18px 12px"
                w="100%"
                justify={"space-between"}
                align={"center"}
                sx={{ borderRadius: "8px" }}
              >
                <Text
                  color={theme.colors.basic[5]}
                  tt="uppercase"
                  fz="12px"
                  fw={500}
                  lh="12px"
                >
                  {t("marketplace.comprar_agora.purchase_step_4.credit_card")}
                </Text>
                <Text
                  color={theme.colors.primary[2]}
                  fz="20px"
                  fw={600}
                  lh="31px"
                >
                  {formatCurrency(selectedPlan?.price || 0)}
                </Text>
              </Flex>
            ) : null}
          </Box>
          <Button fullWidth variant="primary" type="submit" loading={isLoading}>
            {t("marketplace.comprar_agora.purchase_step_4.finish_payment")}
          </Button>
        </>
      ) : (
        <FinishStep />
      )}
    </SectionsForm>
  );
};
export default PurchaseStep4;
